import { createAction, createSlice } from "@reduxjs/toolkit";

const checkEnrollmentSlice = createSlice({
  name: "checkEnrollment",
  initialState: { data: null, isEnrolled: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      state.data = null;
      state.isEnrolled = null;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.data = action.payload.data;
      state.isEnrolled = true;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      state.data = null;
      state.isEnrolled = false;
      /* TODO: reducer for failure*/
    },
    clear(state) {
      state.processing = false;
      state.data = null;
      state.isEnrolled = null;
    },
  },
});

const { name, actions, reducer } = checkEnrollmentSlice;
const checkEnrollmentAction = createAction(name);
const clearCheckEnrollmentAction = actions.clear;

export {
  checkEnrollmentAction,
  clearCheckEnrollmentAction,
  actions as checkEnrollmentActions,
  reducer as checkEnrollmentReducer,
};
